import React, { useState } from "react";
import { Modal, Tag } from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Invite, InviteSection, SplitPane } from "../../components";
import MainLayout from "../../components/MainLayout/MainLayout";
import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { useMediaQuery } from "react-responsive";

const Wrapper = styled.div`
	${tw`p-4 md:(pl-12 pr-12 pt-10) pb-0 `}

	.btnStyle {
		font-size: 0.75rem;
		font-family: "Poppins";
		border: "1px solid #f4f4f8" !important;
	}

	.delBg {
		${tw`h-9 w-9`}
		background: rgb(255, 255, 255, 0.6);
		/* border: 1px solid #ffffff; */
		box-sizing: border-box;
		border-radius: 50%;
	}
	#guest-list {
		&::placeholder {
			color: red;
			opacity: 0.6; /* Firefox */
		}
	}
	#color-picker-tool {
		background: conic-gradient(
			from 180deg at 50% 50%,
			#f15e5f 0deg,
			#ff9249 54.38deg,
			#ffb800 112.5deg,
			#00b6aa 172.5deg,
			#1877f2 240deg,
			#9895ee 316.87deg,
			#f15e5f 360deg
		);
	}
	.ant-radio-button-wrapper:not(:first-child)::before {
		display: none;
	}
	.active {
		${tw`text-appPink! text-xs font-medium shadow`}
		background: rgb(250, 115, 139, 0.2);
		font-family: Poppins;
		line-height: 12px;
		letter-spacing: 0.5px;
	}
	.inactive {
		${tw`text-appTextFaded! text-xs font-medium shadow`}
		background: rgb(175, 178, 181, 0.2);
		font-family: Poppins;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 12px;
		/* identical to box height, or 100% */
		letter-spacing: 0.5px;
		/* Dark */
		color: #32323284;
	}
`;

const Invitation = (props) => {
	const history = useHistory();
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const [showMore, setShowMore] = useState(false);

	const tog = () => {
		setShowMore(!showMore);
	};

	return (
		<MainLayout>
			<Wrapper>
				<div
					tw="inline-flex flex-nowrap items-center gap-2 hover:cursor-pointer mb-4"
					onClick={() => {
						history.goBack();
					}}>
					<ArrowLeftOutlined tw="px-2 py-2 bg-gray-100 rounded-full hover:bg-white" />
					<LandingTitle tw="text-lg md:text-2xl font-bold leading-8 m-0! whitespace-pre">
						My Invitation
					</LandingTitle>
				</div>
				{isMobile && (
					<div tw="flex items-center justify-end">
						<Tag color="pink" tw="rounded" onClick={tog}>
							{showMore ? "Hide" : "Show"} Options
						</Tag>
					</div>
				)}

				<div
					tw="w-full overflow-y-scroll"
					css={hideScrollbar}
					style={{ height: isMobile ? "25rem" : "auto" }}>
					<SplitPane
						hideRightSide={isMobile ? true : false}
						wrapDirection={"column"}
						left={<Invite />}
						right={<InviteSection />}
					/>
				</div>
				<Modal
					footer=""
					visible={showMore}
					centered
					onCancel={() => setShowMore(false)}
					maskClosable={false}>
					<InviteSection />
				</Modal>
			</Wrapper>
		</MainLayout>
	);
};

export default Invitation;
